import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './calculators.component.scss';
var Calculators = /** @class */ (function (_super) {
    tslib_1.__extends(Calculators, _super);
    function Calculators(element) {
        return _super.call(this, element) || this;
    }
    Calculators.prototype.init = function () { };
    Calculators.prototype.bindEvents = function () { };
    return Calculators;
}(Base));
export { Calculators };



//////////////////
// WEBPACK FOOTER
// ./components/calculators/calculators.component.ts
// module id = 164
// module chunks = 0